import React, { Component } from 'react'
import DashboardWidget from './DashboardWidget'
import { connect } from 'react-redux'
import { convertCurrency, currencyToText } from 'utils/converters'
import { calculateBetReturn, calculateTotalProfit } from 'utils/calculations'
import LivefeedContainer from './Livefeed'
import moment from 'moment'
import ReactHighcharts from 'react-highcharts'
import 'css/dashboard.less'
import 'css/dashboardwidget.less'

class Dashboard extends Component {

  constructor(props) {
    super(props)
    this.getROI = this.getROI.bind(this)
    this.getLastBetsGraph = this.getLastBetsGraph.bind(this)
  }

  getROI() {
    const settledBets = this.props.userbets.filter(b => b.status !== 1)
    if (settledBets.length === 0)
      return 0
    const profits = calculateTotalProfit(settledBets, this.props.currencies, this.props.user.currency)
    const wagered = settledBets.map(b => convertCurrency(b.currency, this.props.user.currency, b.wager, this.props.currencies))
      .reduce((a, b) => a + b)
    return Math.round(profits / wagered * 100 * 10) / 10
  }

  getLastBetsGraph() {
    const daysRange = 14
    const daysAgo = +moment().subtract(daysRange, 'days')
    let bets = [...this.props.userbets]
      .filter((bet) => bet.status !== 1 && bet.match.startTime >= daysAgo)
    if (bets.length === 0)
      return -1
    const valueMap = {}
    for (let i = daysRange - 1; i >= 0; i--) {
      valueMap[+moment().subtract(i, 'days').startOf('day')] = 0
    }
    bets.forEach((bet) => {
      const d = +moment(bet.match.startTime).startOf('day')
      const amount = convertCurrency(
        bet.currency,
        this.props.user.currency,
        calculateBetReturn(bet.wager, bet.odds, bet.status) - bet.wager,
        this.props.currencies
      )
      const current = valueMap[d] || 0
      valueMap[d] = current + amount
    })
    const startingBankroll = [
      ...this.props.userbets
    ].filter(bet => bet.status !== 1 && bet.match.startTime < daysAgo)
    .reduce((prev, bet) => (
      prev + convertCurrency(
        bet.currency,
        this.props.user.currency,
        calculateBetReturn(bet.wager, bet.odds, bet.status) - bet.wager,
        this.props.currencies
      )
    ), 0)
    const keys = Object.keys(valueMap).sort((a, b) => a - b).map(k => +k)
    if (keys.length > 0)
      valueMap[keys[0]] += startingBankroll
    for (let i = 1; i < keys.length; i++) {
      valueMap[keys[i]] += valueMap[keys[i-1]]
    }
    return {
      title: {
        text: ''
      },
      yAxis: {
        title: {
          text: 'Profits in ' + this.props.user.currency
        }
      },
      chart: {
        zoomType: 'x',
        type: 'line',
      },
      xAxis: {
        categories: keys.map(k => moment(k).format('Do'))
      },
      plotOptions: {
        spline: {
          marker: {
            enabled: true
          }
        }
      },
      series: [{
        data: keys.map(key => Math.round(valueMap[key], 1)),
        name: 'Total profit'
      }]
    }
  }

  componentDidMount() {
    window.analytics.page('Dashboard')
  }

  render() {
    const graphData = this.getLastBetsGraph()
    let graphContent = <ReactHighcharts config={graphData} />
    if (graphData === -1)
      graphContent = (
        <p className='lead'>
          <div>You haven't placed any bets for the past 14 days! :-(<br />Place some more bets to see some cool analytics.</div>
        </p>
      )
    return (
      <div className='container-fluid dashboard'>
        <div className='col-md-8 col-xs-12'>
          <div className='col-md-4'>
            <DashboardWidget
              icon='ionicons ion-star'
              title={currencyToText(
                calculateTotalProfit(this.props.userbets, this.props.currencies, this.props.user.currency),
                this.props.user.currency)}
              comment='Total profit'
              color='green'
              />
          </div>
          <div className='col-md-4'>
            <DashboardWidget
              icon='ionicons ion-pound'
              title={ this.props.userbets.length }
              comment='Bets placed'
              color='orange'
            />
          </div>
          <div className='col-md-4'>
            <DashboardWidget
              icon='ionicons ion-stats-bars'
              title={ (this.getROI() || 0) + '%' }
              comment='ROI / bet'
              color='blue'
            />
          </div>
          <div className='col-xs-12'>
            <div className='panel'>
              <header className='panel-heading'>
                Your total profit over the past 14 days
              </header>
              <div className='panel-body'>
                { graphContent }
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-4 col-xs-12'>
          <LivefeedContainer user={this.props.user} />
        </div>
      </div>
    )
  }
}

export default connect(state => {
  return {
    userbets: state.userbets,
    currencies: state.currencies,
    news: state.news
  }
})(Dashboard)



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/Dashboard.js
 **/